import React, { useEffect, useState } from 'react'
import { Row, Col, Container, Card, Image } from 'react-bootstrap'
import axios from 'axios'
import Carousel from 'react-bootstrap/Carousel'
import Header from './global/Header'
import Footer from './global/Footer'
import { baseUrl } from '../consts/consts'
import Loader from './global/Loader'
import { excerpt } from '../utils/helper'
import { Link } from 'react-router-dom'

const News = () => {
  const [loader, setLoader] = useState(false)
  const [slider, setSlider] = useState([])
  const [firstNews, setFirstNews] = useState({})
  const [bottomNews, setBottomNews] = useState([])
  const [rightNews, setRightNews] = useState([])
  const [mainNews, setMainNews] = useState([])

  useEffect(() => {
    getSlider()
    getRightNews()
    getBottomNews()
    getMainNews()
  }, [])

  const getSlider = async () => {
    try {
      setLoader(true)
      const { data } = await axios.get(`${baseUrl}/sliders`)

      setSlider(data.data)
      setLoader(false)
    } catch (error) {
      setLoader(false)
    }
  }
  const getRightNews = async () => {
    try {
      setLoader(true)
      const { data } = await axios.get(`${baseUrl}/blogs/tags/right-slider`)

      setFirstNews(data.data.blogs[0])
      setRightNews(data.data.blogs.filter((value, i) => i > 0))
      setLoader(false)
    } catch (error) {
      setLoader(false)
    }
  }

  const getBottomNews = async () => {
    try {
      setLoader(true)
      const { data } = await axios.get(`${baseUrl}/blogs/tags/bottom-slider`)

      setBottomNews(data.data.blogs)
      setLoader(false)
    } catch (error) {
      setLoader(false)
    }
  }
  const getMainNews = async () => {
    try {
      setLoader(true)
      const { data } = await axios.get(`${baseUrl}/blogs/categories`)

      setMainNews(data.data.blogs)
      setLoader(false)
    } catch (error) {
      setLoader(false)
    }
  }
  return (
    <>
      <Header />

      <div className='bodys pb-4 pt-4'>
        <Container>
          <div className='content'>
            <Row>
              <Col md={7}>
                {loader && <Loader />}
                {!loader && (
                  <Carousel className='mb-3'>
                    {slider.length > 0 &&
                      slider.map((slide) => (
                        <Carousel.Item key={slide.id} interval={3000}>
                          <Link to={slide.link} target='_blank'>
                            <img
                              className='d-block w-100'
                              src={slide.image}
                              alt={slide.title}
                              height={'400px'}
                            />
                            <Carousel.Caption>
                              <h3>{slide.title}</h3>
                              <p>{excerpt(slide.description)}</p>
                            </Carousel.Caption>
                          </Link>
                        </Carousel.Item>
                      ))}
                  </Carousel>
                )}

                <Row>
                  {loader && <Loader />}
                  {!loader &&
                    bottomNews.length > 0 &&
                    bottomNews.map((news) => (
                      <Col sm={6} key={news.id}>
                        <Card style={{ marginBottom: 20 }}>
                          <Link to={`/news/${news.slug}`}>
                            <Image
                              src={news.featured_image}
                              width={'100%'}
                              alt={news.title}
                            />
                          </Link>
                          <div className='card-body'>
                            <div className='news-content'>
                              <Link to={`/news/${news.slug}`}>
                                {news.small_description &&
                                  excerpt(news.small_description, 80)}
                              </Link>
                            </div>
                          </div>
                        </Card>
                      </Col>
                    ))}
                </Row>
              </Col>
              <Col md={3}>
                {loader && <Loader />}
                {!loader && firstNews.title && (
                  <div className='issue'>
                    <Link to={`/news/${firstNews.slug}`}>
                      <img
                        src={firstNews.featured_image}
                        alt='breaking news'
                        style={{ width: '100%', height: 'auto' }}
                      />
                      <div className='slider-content'>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: excerpt(firstNews.small_description, 20),
                          }}
                        />
                      </div>
                    </Link>
                  </div>
                )}
                {loader && <Loader />}
                {!loader &&
                  rightNews.length > 0 &&
                  rightNews.map((news) => (
                    <Card style={{ marginTop: 20 }} key={news.id}>
                      <Link to={`/news/${news.slug}`}>
                        <Image
                          src={news.featured_image}
                          width={'100%'}
                          alt='featured'
                        />
                      </Link>
                      <div className='card-body'>
                        <div className='news-content'>
                          <Link to={`/news/${news.slug}`}>
                            {news.small_description &&
                              excerpt(news.small_description, 80)}
                          </Link>
                          {/* <div className='news-bottom'>
                            <div className='d-flex'>
                              <img
                                src={slider1}
                                height='16px'
                                width='16px'
                              />
                              <p>Lorem Ipsum</p>
                            </div>
                          </div> */}
                        </div>
                      </div>
                    </Card>
                  ))}
              </Col>
              <Col md={2}></Col>
            </Row>
            <hr />
          </div>
          {/* ============== */}
          {loader && <Loader />}
          {!loader &&
            mainNews.length > 0 &&
            mainNews.map(
              (category) =>
                category.news.length > 0 && (
                  <React.Fragment key={category.slug}>
                    <div className='trending my-4'>
                      <div className='d-flex'>
                        <h2>{category.name}</h2>
                        {/* <ul>
                        <li>তাজা খবর</li>
                        <li>ठळक बातम्या</li>
                        <li>AP, తెలంగాణ న్యూస్</li>
                        <li>समाचार</li>
                      </ul> */}
                      </div>

                      <div className='my-3'>
                        <Row>
                          {category.news.map((cnews) => (
                            <Col md={4} style={{ marginBottom: 30 }} key={cnews.slug}>
                              <Card className='overflow-hidden'>
                                <Link to={`/news/${cnews.slug}`}>
                                  <img
                                    src={cnews.featured_image}
                                    className='img-fluid'
                                    alt={cnews.title}
                                  />
                                </Link>
                                <div className='card-body'>
                                  <Link to={`/news/${cnews.slug}`}>
                                    <p>
                                      {excerpt(cnews.small_description, 80)}
                                    </p>
                                  </Link>
                                </div>
                              </Card>
                            </Col>
                          ))}
                          {/* <Col md={6}>
                            <Row>
                              {category.news.map((cnews) => (
                                <Col md={6}>
                                  <Card>
                                    <Card className='dummy'>
                                      <div className='card-body'>
                                        <Row>
                                          <Col md={4}>
                                            <img
                                              src={cnews.featured_image}
                                              height={'85px'}
                                              width={'100%'}
                                              alt={cnews.title}
                                            />
                                          </Col>
                                          <Col md={8}>
                                            <div className='news-content'>
                                              <Link to={`/news/${cnews.slug}`}>
                                                {excerpt(
                                                  cnews.small_description,
                                                  50
                                                )}
                                              </Link>
                                            </div>
                                          </Col>
                                        </Row>
                                      </div>
                                    </Card>
                                  </Card>
                                </Col>
                              ))}
                            </Row>
                          </Col> */}

                          {/* <Col md={3}>
                            <Card>
                              <Link
                                to={`/news/${
                                  category.news[category.news.length - 1].slug
                                }`}
                              >
                                <img
                                  src={
                                    category.news[category.news.length - 1]
                                      .featured_image
                                  }
                                  className='img-fluid'
                                  alt={
                                    category.news[category.news.length - 1]
                                      .title
                                  }
                                />
                              </Link>
                              <div className='card-body'>
                                <Link
                                  to={`/news/${
                                    category.news[category.news.length - 1].slug
                                  }`}
                                >
                                  <p>
                                    {excerpt(
                                      category.news[category.news.length - 1]
                                        .title,
                                      50
                                    )}
                                  </p>
                                </Link>
                              </div>
                            </Card>
                          </Col> */}
                        </Row>
                      </div>
                    </div>
                    <hr />
                  </React.Fragment>
                )
            )}
        </Container>
      </div>
      <Footer />
    </>
  )
}

export default News
